import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

const statusTone = (s) => {
  const v = (s || '').toString().toUpperCase();
  if (v === 'POST') return { bg: '#e6f7ee', fg: '#15803d', bd: '#16a34a' };
  if (v === 'ENTER') return { bg: '#fff7e6', fg: '#b45309', bd: '#f59e0b' };
  return { bg: '#eef2f7', fg: '#475569', bd: '#94a3b8' };
};

const Row = ({ label, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, py: 0.2, minWidth: 0 }}>
    <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', minWidth: 86, flexShrink: 0 }}>
      {label}
    </Typography>
    <Typography
      title={value || ''}
      sx={{
        fontSize: 13,
        fontWeight: 600,
        color: '#1a2a3a',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize'
      }}>
      {value || '—'}
    </Typography>
  </Box>
);

export default function DCTransferCard({ row, onClick }) {
  const tone = statusTone(row?.T_DocStat);
  const tsr =
    row?.TSRVocNo && row?.TSRVocNo !== ''
      ? `${row?.TSRVocTyp || ''} - ${row?.TSRVocNo}`
      : '';
  return (
    <Box
      onClick={onClick}
      sx={{
        bgcolor: '#fff',
        border: '1px solid #e6ebf2',
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow .15s, transform .15s',
        '&:hover': onClick
          ? { boxShadow: '0 4px 14px rgba(15,23,42,0.12)', transform: 'translateY(-1px)' }
          : {}
      }}>
      {/* header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
          color: '#fff',
          px: 1.5,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
        <Inventory2OutlinedIcon sx={{ fontSize: 18, opacity: 0.9 }} />
        <Typography sx={{ fontSize: 15, fontWeight: 700, flex: 1, letterSpacing: 0.3, color: '#fff' }}>
          {row?.T_VocNo}
        </Typography>
        <Chip
          label={(row?.T_DocStat || '').toString().toUpperCase()}
          size="small"
          sx={{
            height: 20,
            fontSize: 10,
            fontWeight: 700,
            color: tone.fg,
            bgcolor: tone.bg,
            border: `1px solid ${tone.bd}`
          }}
        />
      </Box>

      {/* voucher name */}
      <Box sx={{ px: 1.5, pt: 1 }}>
        <Typography
          title={row?.vocName || ''}
          sx={{
            fontSize: 14,
            fontWeight: 700,
            color: '#7c3aed',
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
          {row?.vocName || row?.T_VocTyp || '—'}
        </Typography>
      </Box>

      {/* details */}
      <Box sx={{ px: 1.5, py: 1 }}>
        <Row label="Branch" value={row?.LocName} />
        <Row label="DC Loc" value={row?.DCLocName} />
        <Row label="Department" value={row?.Department} />
        {tsr !== '' && <Row label="Transfer No" value={tsr} />}
      </Box>
    </Box>
  );
}
